module.exports = __webpack_public_path__ + "static/whiteThree-4ec3f487010db20b58eb2efad5ae00a6.png";